import React, { useRef } from "react";
import Navbar from "../../components/landing/Navbar";
import BannerIndex from "../../components/landing/banner/BannerIndex";
import Slider from "../../components/landing/Slider";
import BannerAbout from "../../components/landing/banner/BannerAbout";
import Footer from "../../components/landing/Footer";

const Home = () => {
  const conocenosRef = useRef(null);
  const contactoRef = useRef(null);

  return (
    <>
      <Navbar
        onNavigate={(section) => {
          if (section === "conocenos")
            conocenosRef.current?.scrollIntoView({ behavior: "smooth" });
          if (section === "contacto")
            contactoRef.current?.scrollIntoView({ behavior: "smooth" });
        }}
      />
      <div className="mt-5">
        <BannerIndex aboutRef={conocenosRef} />
        <Slider />
        <div ref={conocenosRef}>
          <BannerAbout />
        </div>
        <div ref={contactoRef}>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Home;
